import { useReactiveVar } from "@apollo/client";
import type { ToastProps as _ToastProps } from "@dmm-com/rocket-web-ui-library/es6/components/toast";
import { memo, useEffect } from "react";
import { toastState, closeToast } from "~/components/stores/toast/store";
import { Toast } from "~/components/templates/common/toast/style";

type ToastProps = Pick<_ToastProps, "vertical" | "horizontal">;

export const ToastStore = memo((props: ToastProps) => {
  const { horizontal, vertical } = props;

  const state = useReactiveVar(toastState);

  useEffect(() => {
    return () => closeToast();
  }, []);

  return <Toast position="fixed" {...state} onHideToast={closeToast} horizontal={horizontal} vertical={vertical} />;
});

ToastStore.displayName = "ToastStore";
